import {
  Component,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { Router } from '@angular/router';
import { NewActionInputParam } from '../../../models/common/new-action-input-param.model';
import {
  InventoryLevelUpdateDto,
  InventoryLevelUpdateGridDataDto,
} from '../../../models/change-sar/inventory-level-update.model';
import { InventoryLevelUpdateService } from '../../../services/inventory-level-update.service';
import { SelectionEvent } from '@progress/kendo-angular-grid';
import { CommonService } from 'src/app/core/services/common.service';
import { ApprovalDetailsConstants } from 'src/app/core/constants/approval-details.constants';
import {
  ApprovalMMDActionDetail,
  ApprovalSAActionDetail,
} from '../../../models/approval-details/action-detail.model';
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { ApprovalAssignmentComponent } from '../approval-assignment/approval-assignment.component';
import { ConsultNewActionDto } from '../../../models/add-new-action/consult-new-action.model';
import { AddNewActionService } from '../../../services/add-new-action.service';
import { forkJoin } from 'rxjs';
import { QACodeDto } from 'src/app/features/setup/models/qacode/qacode.model';
import { GroupDto } from 'src/app/features/setup/models/userandrole/group.model';
import { UserDto } from 'src/app/features/setup/models/userandrole/user.model';
import { DatePipe, Location } from '@angular/common';
import { BulkActionComponent } from 'src/app/core/components/bulk-action/bulk-action.component';
import { InventoryLevelUpdateABUColumns } from 'src/app/core/constants/excel-columns-const';
import { ApprovalDetailService } from '../../../services/approvalDetail/approval-details.service';
import { GetTimelines } from '../../../models/approval-details/get-approval-details.model';
import { SharedConst } from 'src/app/core/constants/shared.constant';
import * as FileSaver from 'file-saver';
import { AddNewActionItemsAttachmentDetailsDisplay } from '../../../models/common/action-attachment.model';
import { TempActionService } from '../../../services/temp-action.service';
import { ExpansionPanelComponent } from '@progress/kendo-angular-layout';
import { SmeReviewPopupComponent } from '../sme-review-popup/sme-review-popup.component';
import { ConsultAssignmentPopupComponent } from '../consult-assignment-popup/consult-assignment-popup.component';
import { SarUsersService } from 'src/app/features/setup/services/sar-users.service';

@Component({
    selector: 'app-inventory-level-update-approval',
    templateUrl: './inventory-level-update-approval.component.html',
    styleUrls: ['./inventory-level-update-approval.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class InventoryLevelUpdateApprovalComponent {
  @Input() public requiredParams: NewActionInputParam = {};
  @Input() public currentActionName: string = '';
  @Input() public dummyInput: number = 0; // approach for triggering "ngOnChanges()" to refresh the item list
  @Input() public isABU: boolean;
  @Input() public isAdminRole: boolean;

  @Output() saActionEvent = new EventEmitter<ApprovalSAActionDetail>();
  @Output() mmdActionEvent = new EventEmitter<ApprovalMMDActionDetail>();
  @Output() mmdBulkActionEvent = new EventEmitter<ApprovalMMDActionDetail[]>();
  @Output() saBulkActionEvent = new EventEmitter<ApprovalSAActionDetail[]>();

  private abuName: string = 'ABU';
  @ViewChildren(ExpansionPanelComponent)
  panels: QueryList<ExpansionPanelComponent>;
  mainGridData: InventoryLevelUpdateDto[] = [];
  nestedGridData: InventoryLevelUpdateGridDataDto[] =
    this.mainGridData.length > 0
      ? this.mainGridData[0].inventoryLevelUpdateGridData
      : [];
  showGridSection = false;
  isBulk: boolean = false;
  mySelection: number[] = [];
  consultAction: ConsultNewActionDto = { GroupId: -1 };
  qaCodes: QACodeDto[] = [];
  buName: string = '';
  selectedQaCode?: QACodeDto;
  consultComment: string = '';
  timelineDetails: GetTimelines[] = [];
  dateFormatWithTime: string = SharedConst.dateFormatWithTime;

  requestIssueId: number = 0;
  isSMEReviewAction: boolean = false;

  qaCodeSelectPlaceHolder: QACodeDto = {
    name: 'Select QA code',
    id: -1,
  };

  constructor(
    public router: Router,
    private inventoryLevelUpdateService: InventoryLevelUpdateService,
    private addNewActionService: AddNewActionService,
    private location: Location,
    private dialogService: DialogService,
    public commonService: CommonService,
    private approvalDetailService: ApprovalDetailService,
    public datepipe: DatePipe,
    private tempActionService: TempActionService,
    private userService: SarUsersService
  ) { }

  ngOnChanges(): void {
    this.buName = this.commonService.getUserBUName();
    this.requestIssueId = this.requiredParams.requestIssueId!;
    this.getInventoryLevelUpdateData();
    this.getTimelineDetails();
  }

  getTimelineDetails(): void {
    this.approvalDetailService
      .getTimelines(this.requiredParams.requestIssueId!)
      .subscribe((data: any) => {
        if (data) {
          data.map((ele: any) => {
            ele.createdDate = new Date(ele.createdDate + 'Z');
            this.timelineDetails = data;
          });
        }
      });
  }

  downloadAll(i: number) {
    let date = new Date();
    const dateFormat = this.datepipe.transform(date, 'YYYY-MM-dd-HHmmss');
    let zipFileName = `${this.requiredParams.requestNumber}_${dateFormat}`;
    this.approvalDetailService
      .downloadAllAttachements(zipFileName, this.timelineDetails[i].attachments)
      .subscribe((data: any) => {
        const blob = new Blob([data], { type: 'application/zip' });
        const url = window.URL.createObjectURL(blob);
        FileSaver.saveAs(url, zipFileName);
      });
  }

  downloadFile(timelineIndex: number, index: number) {
    if (
      this.timelineDetails[timelineIndex].attachments &&
      this.timelineDetails[timelineIndex].attachments[index]
    ) {
      let attachment: AddNewActionItemsAttachmentDetailsDisplay =
        this.timelineDetails[timelineIndex].attachments[index];
      if (attachment.attachmentId !== 0) {
        this.tempActionService
          .downLoadAttachment(attachment.blobUrI!)
          .subscribe((response: Blob) => {
            this.commonService.downloadFile(response, attachment.fileName!);
          });
      } else {
        const blob = new Blob([attachment.file!], {
          type: attachment.file!.type,
        });
        this.commonService.downloadFile(blob, attachment.fileName!);
      }
    }
  }

  removeFile(timelineIndex: number, index: number) {
    if (
      this.timelineDetails[timelineIndex].attachments &&
      this.timelineDetails[timelineIndex].attachments[index]
    ) {
      let attachment: AddNewActionItemsAttachmentDetailsDisplay =
        this.timelineDetails[timelineIndex].attachments[index];
      if (attachment.attachmentId !== 0) {
        this.approvalDetailService
          .deleteTimelineAttachement(
            this.timelineDetails[timelineIndex].requestEntryId!,
            attachment.attachmentId!
          )
          .subscribe((data: any) => { });
      }
      this.timelineDetails[timelineIndex].attachments!.splice(index, 1);
    }
  }

  downloadExcel(): void {
    let convertedArr = [];
    for (let item of this.mainGridData) {
      let obj = {
        materialNumber: item.materialNumber,
        unitPrice: item.unitPrice,
        annualUsageForecast: item.annualUsageForecast,
        requesterNotes: item.requesterNotes,
        itemDescription: item.itemDescription,
        status: item.itemStatus,
        locationCode:
          item.inventoryLevelUpdateGridData?.map((x) => x.code).join(',') ?? '',
        recommendedMinimum:
          item.inventoryLevelUpdateGridData
            ?.map((x) => x.recommendedMinimum)
            .join(',') ?? '',
        existingMinimum:
          item.inventoryLevelUpdateGridData
            ?.map((x) => x.existingMinimum)
            .join(',') ?? '',
        recommendedMaximum:
          item.inventoryLevelUpdateGridData
            ?.map((x) => x.recommendedMaximum)
            .join(',') ?? '',
        existingMaximum:
          item.inventoryLevelUpdateGridData
            ?.map((x) => x.existingMaximum)
            .join(',') ?? '',
        totalValue: item.totalValue,
        changeInValue: item.changeInValue,
        comments: item.comment ?? '',
      };
      convertedArr.push(obj);
    }
    let date = new Date().toISOString();
    date = date
      .substring(0, date.lastIndexOf(':'))
      .replace('T', '-')
      .replace(':', '-');
    let fileName =
      this.requiredParams.requestNumber +
      '-Action-' +
      this.requiredParams.actionNumber +
      '-' +
      'Item-Export-' +
      date;
    this.commonService.exportAsExcelFile(
      convertedArr,
      InventoryLevelUpdateABUColumns,
      fileName
    );
  }

  bulk(): void {
    if (this.currentActionName === 'sme-action') {
      let requestLineIds = [];
      for (let selectedValue of this.mySelection) {
        let dataItem =
          this.mainGridData[selectedValue];
        requestLineIds.push(dataItem.id);
      }
      let consultAction: ConsultNewActionDto = { GroupId: -1 };
      consultAction.RequestLineIds = requestLineIds;
      consultAction.RequestId = this.requiredParams.requestId;
      consultAction.RequestIssueTypeId = 6;
      consultAction.RequestIssueId = this.requiredParams.requestIssueId!;
      this.showSMEReviewPopup(consultAction, true);
    } else {
      let isComplete = false;
      if (this.currentActionName === 'mmd-action') {
        for (let index of this.mySelection) {
          if (
            this.commonService.isNullOrEmptyOrUndefined(
              this.mainGridData[index].materialNumber
            ) ||
            !Number(this.mainGridData[index].materialNumber)
          ) {
            isComplete = true;
            break;
          }
        }
      }
      const dialog: DialogRef = this.dialogService.open({
        content: BulkActionComponent,
      });
      const inc = dialog.content.instance as BulkActionComponent;
      inc.isMMD = this.currentActionName === 'mmd-action' ? true : false;
      inc.isCompleteDisable = isComplete;
      inc.isABUUnit = this.isABU;
      inc.changeType = this.requiredParams.changeType!;
      dialog.result.subscribe((r: any) => {
        if (
          this.commonService.isNullOrEmpty(r.action) ||
          r.action === 'Close'
        ) {
          return false;
        }
        this.bulkAction(r.action, r.comment, r.lineItemDtail);
      });
    }
  }

  bulkAction(actionType: string, comment: string, lineItemDtail: any) {
    if (actionType === 'Consult') {
      let consultAction = lineItemDtail;
      this.bulkConsult(this.mySelection, comment, consultAction);
    } else {
      if (this.currentActionName === 'mmd-action') {
        let approvalMMDActionDetail: ApprovalMMDActionDetail[] = [];
        for (let selectedValue of this.mySelection) {
          let dataItem = this.mainGridData[selectedValue];
          if (dataItem.status !== 'Pending MMD') {
            continue;
          }
          dataItem.comment = comment;
          let approvalActionDetail = this.getmmdValues(dataItem);
          if (actionType === 'Cancel') {
            approvalActionDetail.mmdAction = 3;
          }
          if (actionType === 'Reject') {
            approvalActionDetail.mmdAction = 1;
          }
          if (actionType === 'Complete') {
            approvalActionDetail.mmdAction = 2;
          }
          approvalMMDActionDetail.push(approvalActionDetail);
        }
        this.mmdBulkActionEvent.emit(approvalMMDActionDetail);
      }
      if (this.currentActionName === 'sa-action') {
        let approvalSAActionDetail: ApprovalSAActionDetail[] = [];
        for (let selectedValue of this.mySelection) {
          let dataItem = this.mainGridData[selectedValue];
          if (dataItem.status !== 'Pending Stocking Approval') {
            continue;
          }
          dataItem.comment = comment;
          let approvalActionDetail = this.getsaValues(dataItem);
          if (actionType === 'Cancel') {
            approvalActionDetail.stockApproverAction = 3;
            approvalActionDetail.assignedGroupId = null;
            approvalActionDetail.assignedUserId = null;
          }
          if (actionType === 'Reject') {
            approvalActionDetail.stockApproverAction = 1;
            approvalActionDetail.assignedGroupId = null;
            approvalActionDetail.assignedUserId = null;
          }
          if (actionType === 'Complete') {
            approvalActionDetail.stockApproverAction = 2;
            approvalActionDetail.assignedGroupId =
              lineItemDtail.assignedGroupId;
            approvalActionDetail.assignedUserId = lineItemDtail.assignedUserId;
          }
          approvalSAActionDetail.push(approvalActionDetail);
        }
        this.saBulkActionEvent.emit(approvalSAActionDetail);
      }
    }
  }

  bulkConsult(
    mySelection: number[],
    comment: string,
    consultAction: ConsultNewActionDto
  ) {
    let requestLineIds = [];
    for (let selectedValue of mySelection) {
      let dataItem = this.mainGridData[selectedValue];
      requestLineIds.push(dataItem.id);
    }

    if (requestLineIds !== undefined && requestLineIds.length > 0) {
      consultAction.RequestLineIds = requestLineIds;
      consultAction.UserEmailId = this.commonService.getUserEmailId();
      consultAction.RequestId = this.requiredParams.requestId;
      consultAction.Comment = comment;
      consultAction.RequestIssueTypeId = 6;
      consultAction.RequestIssueId = this.requiredParams.requestIssueId!;

      this.addNewActionService
        .updateOnBulkConsultAction(consultAction)
        .subscribe(() => {
          this.location.back();
        });
    }
  }

  getInventoryLevelUpdateData() {
    let req1 = this.userService
      .GetAllUserDetailsByEmail(this.commonService.getUserEmailId());

    let req2 = this.inventoryLevelUpdateService
      .getInventoryLevelUpdateData(
        this.requiredParams.requestId!,
        this.requiredParams.requestIssueId!
      );

    forkJoin(req1, req2)
      .subscribe((response) => {
        let userDetails = response[0];
        if (response[1]) {
          let data = response[1];
          if (data[0].totalValue === 0) {
            this.showGridSection = true;
          }
          this.mainGridData = data;
          if (this.currentActionName === 'sme-action') {
            this.isSMEReviewAction = true;
            let currentUserId = userDetails.id;
            let userGroups = userDetails.groupDtos?.map((group) =>
              group.id
            );
            this.mainGridData = this.mainGridData.filter(
              (x) => x.status === 'Pending SME Review' && (this.isAdminRole || x.assignedUser === currentUserId || userGroups?.includes(x.assignedGroup))
            );
          }
          if (this.currentActionName === 'sa-action') {
            this.mainGridData = this.mainGridData.filter(
              (x) => x.status === 'Pending Stocking Approval'
            );
          }
          if (this.currentActionName === 'mmd-action') {
            this.mainGridData = this.mainGridData.filter(
              (x) => x.status !== 'Pending SME Review' && x.status !== 'Pending Stocking Approval'
            );
          }
          this.nestedGridData =
            this.mainGridData.length > 0
              ? this.mainGridData[0].inventoryLevelUpdateGridData
              : [];
        }
      });
  }

  selectionChange(e: SelectionEvent): void {
    this.isBulk = this.mySelection.length > 1;
  }

  getLocationsCodes(data?: InventoryLevelUpdateGridDataDto[]): string {
    return data?.map((item) => item.code).join(',') ?? '';
  }

  getSAButtonText(): string {
    if (this.currentActionName === 'sa-action') {
      return 'Approve';
    } else {
      return 'Complete';
    }
  }

  addSMEReview(dataItem: InventoryLevelUpdateDto) {
    let consultAction: ConsultNewActionDto = { GroupId: -1 };
    consultAction.Id = dataItem.id;
    consultAction.RequestLineId = dataItem.id;
    consultAction.Status = dataItem.status;
    consultAction.RequestId = this.requiredParams.requestId;
    consultAction.RequestIssueTypeId = 6;
    consultAction.RequestIssueId = this.requiredParams.requestIssueId!;
    this.showSMEReviewPopup(consultAction, false);
  }

  showSMEReviewPopup(
    consultAction: ConsultNewActionDto,
    isBulkAction: boolean
  ) {
    const dialog: DialogRef = this.dialogService.open({
      content: SmeReviewPopupComponent,
    });
    const inc = dialog.content.instance as SmeReviewPopupComponent;
    inc.isBulkAction = isBulkAction;
    dialog.result.subscribe((r: any) => {
      if (this.commonService.isNullOrEmpty(r.actionType) || r.actionType === 'close') {
        return false;
      }
      if (
        !this.commonService.isNullOrEmpty(r.actionType) &&
        r.actionType === 'submit'
      ) {
        consultAction.UserEmailId = this.commonService.getUserEmailId();
        consultAction.Comment = r.comment;

        if (r.bulkAction) {
          this.addNewActionService
            .addBulkSMEReviewOnConsultAction(consultAction)
            .subscribe(() => {
              this.location.back();
            });
        } else {
          this.addNewActionService
            .addSMEReviewOnConsultAction(consultAction)
            .subscribe(() => {
              this.location.back();
            });
        }
      }
    });
  }

  consult(dataItem: InventoryLevelUpdateDto): void {
    this.consultAction.Id = dataItem.id;
    this.consultAction.RequestLineId = dataItem.id;
    this.consultAction.Status = dataItem.itemStatus;
    this.consultAction.Comment = '';
    const dialog: DialogRef = this.dialogService.open({
      content: ConsultAssignmentPopupComponent
    });
    dialog.result.subscribe((r: any) => {
      if (r.actionType == 'submit') {
        this.consultAction.GroupId = r.lineItemDtail!.GroupId;
        this.consultAction.UserGroupId = r.lineItemDtail!.UserGroupId;
        this.consultAction.Comment = r.comment;
        this.consultAction.UserEmailId = this.commonService.getUserEmailId();
        this.consultAction.RequestId = this.requiredParams.requestId;
        this.consultAction.RequestIssueTypeId = 6;
        this.consultAction.RequestStateId = this.requiredParams.requestStateId;
        this.consultAction.RequestIssueId = this.requiredParams.requestIssueId!;

        this.addNewActionService
          .updateOnConsultAction(this.consultAction)
          .subscribe(() => {
            this.location.back();
          });
      }
    });
  }

  qaCodeSelectionChange(value: QACodeDto): void {
    if (value != undefined) {
      this.selectedQaCode = value;
    }
  }

  reject(dataItem: InventoryLevelUpdateDto): void {
    this.commonService
      .showConfirmation('Rejection', ApprovalDetailsConstants.rejectMessage)
      .subscribe((res: any) => {
        if (res.action === 'yes') {
          if (this.currentActionName === 'mmd-action') {
            let approvalActionDetail = this.getmmdValues(dataItem);
            approvalActionDetail.mmdAction = 1;
            approvalActionDetail.comment = dataItem.comment;
            this.mmdActionEvent.emit(approvalActionDetail);
          }
          if (this.currentActionName === 'sa-action') {
            let approvalActionDetail = this.getsaValues(dataItem);
            approvalActionDetail.assignedGroupId = null;
            approvalActionDetail.assignedUserId = null;
            approvalActionDetail.stockApproverAction = 1;
            approvalActionDetail.comment = dataItem.comment;
            this.saActionEvent.emit(approvalActionDetail);
          }
        }
      });
  }

  complete(dataItem: InventoryLevelUpdateDto): void {
    if (this.currentActionName === 'mmd-action') {
      this.commonService
        .showConfirmation('Complete', ApprovalDetailsConstants.completeMessage)
        .subscribe((res: any) => {
          if (res.action === 'yes') {
            let approvalActionDetail = this.getmmdValues(dataItem);
            approvalActionDetail.mmdAction = 2;
            approvalActionDetail.comment = dataItem.comment;
            this.mmdActionEvent.emit(approvalActionDetail);
          }
        });
    }

    if (this.currentActionName === 'sa-action') {
      let approvalActionDetail = this.getsaValues(dataItem);
      const dialog: DialogRef = this.dialogService.open({
        content: ApprovalAssignmentComponent,
      });
      dialog.result.subscribe((r: any) => {
        if (r.actionType == 's') {
          approvalActionDetail.assignedGroupId =
            r.lineItemDtail.assignedGroupId;
          approvalActionDetail.assignedUserId =
            this.commonService.isNullOrEmptyOrUndefined(
              r.lineItemDtail.assignedUserId
            )
              ? null
              : r.lineItemDtail.assignedUserId;
          approvalActionDetail.stockApproverAction = 2;
          approvalActionDetail.comment = dataItem.comment;
          this.saActionEvent.emit(approvalActionDetail);
        }
      });
    }
  }

  private getmmdValues(
    dataItem: InventoryLevelUpdateDto
  ): ApprovalMMDActionDetail {
    let approvalMMDActionDetail: ApprovalMMDActionDetail =
      new ApprovalMMDActionDetail();
    approvalMMDActionDetail.comment = dataItem.comment;
    approvalMMDActionDetail.createdBy = this.commonService.getUserEmailId();
    approvalMMDActionDetail.enrichedDescription = '';
    approvalMMDActionDetail.materialNumber = '';
    approvalMMDActionDetail.shortDescription = '';
    approvalMMDActionDetail.modifiedBy = this.commonService.getUserEmailId();
    approvalMMDActionDetail.requestIssueId =
      this.requiredParams.requestIssueId!;
    approvalMMDActionDetail.requestIssueTypeId = 6;
    approvalMMDActionDetail.requestLineId = dataItem.id!;
    approvalMMDActionDetail.requestId = this.requiredParams.requestId!;
    return approvalMMDActionDetail;
  }

  private getsaValues(
    dataItem: InventoryLevelUpdateDto
  ): ApprovalSAActionDetail {
    let approvalMMDActionDetail: ApprovalSAActionDetail =
      new ApprovalSAActionDetail();
    approvalMMDActionDetail.comment = dataItem.comment;
    approvalMMDActionDetail.createdBy = this.commonService.getUserEmailId();
    approvalMMDActionDetail.modifiedBy = this.commonService.getUserEmailId();
    approvalMMDActionDetail.requestIssueId =
      this.requiredParams.requestIssueId!;
    approvalMMDActionDetail.requestIssueTypeId = 6;
    approvalMMDActionDetail.requestLineId = dataItem.id!;
    approvalMMDActionDetail.requestId = this.requiredParams.requestId!;
    return approvalMMDActionDetail;
  }
}
